import StoredLayout from '../../layouts/StoredLayout'
import ReactSelectView from './ReactSelectView'
export default StoredLayout(ReactSelectView)
